import { movieDirectorsFilmographyQuery } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { MovieOverviewSelectionsQueryContext } from './overview';

export type MovieOverviewSelectionType = 'director';

export const SELECTIONS_ORDER = ['director'] as const;

const SELECTIONS_LIMIT = 20;

export const registry = {
    director: async (ctx: MovieOverviewSelectionsQueryContext) => {
        const res = await ctx.client.fetch({
            operation: movieDirectorsFilmographyQuery,
            variables: {
                contentId: ctx.contentId,
                offset: 0,
                limit: SELECTIONS_LIMIT,
                withUserData: ctx.withUserData,
                withRating: ctx.withRating,
            },
        });

        return {
            items:
                res.data?.items?.map((director) => ({
                    typename: 'DefaultSelection' as const,
                    type: 'director' as const,
                    id: String(director.id),
                    key: String(director.id),
                    title: ctx.i18n('selection_director', { director: director.name }),
                    comment: '',
                    offset: 0,
                    hasMore: false,
                    sessionId: res.requestId ?? '',
                    showcaseId: undefined,
                    items: director.filmography.items,
                })) ?? [],
            errors: res.errors,
            requestId: res.requestId ?? '',
        };
    },
};
